export default "__VITE_ASSET__BqVdGQGj__"